import { NgModule } from '@angular/core';
import { BackendModule } from './backend/backend.module';
import { StateModule } from './state/state.module';

@NgModule({
  imports: [BackendModule, StateModule]
})
export class NotificationsDataModule {}
